define([], function () {
  function HeroCarousel(args, animSpd) {
    const heroCarousel = args.scope.querySelector(".hero-carousel");
    const slider = args.scope.querySelector(".hero-carousel-slide-container");
    const nav = args.scope.querySelector(".hero-carousel-nav .nav");
    let animation = false;
    let curSlide = 1;
    let autoScrollVar = true;
    const slides = getSlides();
    const slideCount = slides.length;

    function getHiddenClasses() {
      return Array.from(
        args.scope.querySelectorAll(
          ".hero-carousel-visibility > div[style*='display: none']"
        )
      ).map((el) => el.className);
    }


    function slideIsVisible(slide) {
      const hiddenClasses = getHiddenClasses();
      for (const hiddenClass of hiddenClasses) {
        if (slide.querySelector("div")?.classList.contains(hiddenClass)) {
          return false;
        }
      }
      return true;
    }

    
    function getSlides() {
      const slidesArray = [];
      const allSlides = slider.querySelectorAll(".hero-carousel-slide");

      for (const slide of allSlides) {
        if (slideIsVisible(slide)) {
          slidesArray.push(slide);
        }
      }

      return slidesArray;
    }

    
    function addBullets() {
      for (let i = 1; i <= slideCount; i++) {
        const li = document.createElement("li");
        li.dataset.target = i;
        li.className = `nav__slide nav__slide--${i}`;
        nav.appendChild(li);
      }

      const lastLi = document.createElement("li");
      lastLi.dataset.target = slideCount + 1;
      lastLi.className = `last_nav_slide nav__slide nav__slide--${
        slideCount + 1
      }`;
      nav.append(lastLi);

      nav.querySelector(".nav__slide--1").classList.add("nav-active");
    }

   
    function bullets(dir) {
      const activeBullet = nav.querySelector(`.nav__slide--${curSlide}`);
      if (activeBullet) activeBullet.classList.remove("nav-active");

      const targetBullet = nav.querySelector(`.nav__slide--${dir}`);
      if (targetBullet) targetBullet.classList.add("nav-active");
    }

   
    function timeout() {
      animation = false;
    }

    function animationTimeout() {
      if (animSpd > 0) {
        setTimeout(timeout, animSpd * 1000);
      } else {
        timeout();
      }
    }

    
    function actionVideo(slide, action) {
      const video = slide.querySelector("video");

      if (video) {
        const isPlaying =
          video.currentTime > 0 &&
          !video.paused &&
          !video.ended &&
          video.readyState > video.HAVE_CURRENT_DATA;

        if (action === "play" && !isPlaying) {
          video.play();
        } else if (action === "pause" && isPlaying) {
          video.pause();
        }
      }
    }

    function playVideo(slide) {
      actionVideo(slide, "play");
      const videoElement = slide.querySelector("video");
      const playButton = slide.querySelector(".hero-video--controls-play");
      const pauseButton = slide.querySelector(".hero-video--controls-pause");

      // Check if video is currently playing
      if (
        videoElement &&
        videoElement.currentTime > 0 &&
        !videoElement.paused &&
        !videoElement.ended &&
        videoElement.readyState > 2
      ) {
        playButton.style.display = "none";
        pauseButton.style.display = "block";
      }
    }

 
    function pauseVideo(slide) {
      actionVideo(slide, "pause");
    }

    
    function pagination(dir) {
      animation = true;
      slider.classList.add("animation");

      const fromElement = slides[curSlide - 1];
      const toElement = slides[dir - 1];

       if (curSlide < slideCount) {
         SetupAnimation(fromElement, toElement);
         StartAnimation(toElement);
       } else {
         RemoveAnimation(toElement);
       }

      fromElement.classList.add("hide");
      pauseVideo(fromElement);
      toElement.classList.remove("hide");
      playVideo(toElement);
      animationTimeout();
    }

    function navigateNext() {
      if (!autoScrollVar || curSlide >= slideCount) return;
      pagination(curSlide + 1);
      bullets(curSlide + 1);
      curSlide++;
    }

    function navigatePrevious() {
      if (curSlide <= 1) return;
      pagination(curSlide - 1);
      bullets(curSlide - 1);
      curSlide--;
    }

    function firstSlide() {
      return curSlide == 1;
    }

    function lastSlide() {
      return curSlide >= slideCount;
    }

    function navigateAfter(scrollDown) {
      animation = false;
      if (scrollDown) {
        window.scrollBy(0, slider.offsetHeight);
      }
    }
    
    function RemoveAnimation(toElement) {
      const animations = toElement.querySelectorAll(".svgLayer svg animate");
      animations.forEach((animation) => animation.remove());
    }
    
    function SetupAnimation(fromElement, toElement) {
      RemoveAnimation(toElement);

      const fromPaths = fromElement.querySelectorAll(".svgLayer path");
      const toPaths = toElement.querySelectorAll(".svgLayer path");

      const maxCount = Math.min(fromPaths.length, toPaths.length);

      for (let i = 0; i < maxCount; i++) {
        const toIdPath = toPaths[i].getAttribute("id");
        const dSource = fromPaths[i].getAttribute("d");
        const dTarget = toPaths[i].getAttribute("d");

        const animate = `<animate xlink:href="#${toIdPath}" attributeName="d" attributeType="XML" dur="${animSpd}s" begin="0s" fill="freeze" values="${dSource};${dTarget}" />`;

        toElement.querySelector("svg").innerHTML += animate;
      }
    }

    function StartAnimation(toElement) {
      const svgElement = toElement.querySelector(".svgLayer");
      svgElement.innerHTML = svgElement.innerHTML;
    }


     // Events
    function addEventListeners() {
      nav.addEventListener("click", function (e) {
        if (
          e.target.classList.contains("nav__slide") &&
          !e.target.classList.contains("nav-active")
        ) {
          const target = parseInt(e.target.dataset.target);
           if (target > slideCount) {
             navigateAfter(true);
             return;
           }
          bullets(target);
          pagination(target);
          curSlide = target;
          animation = false;
        }
      });

 
      document.addEventListener("keydown", function (e) {
        if (args.scope.querySelector(".hero-carousel:hover")) {
          if (animation) return;
          
          if ([
                33, // Page Up 
                38, // Arrow Up
                37  // Arrow Left
          ].includes(e.which)) {
            if (!firstSlide()) {
              e.preventDefault();
            }
            navigatePrevious();
          }
          if ([
                13, // Enter Key
                34, // Page Down
                40, // Arrow Down
                39, // Arrow Rigt
                32 // Spacebar
          ].includes(e.which)) {
             if (lastSlide()) {
               navigateAfter(false);
               return;
             }
             if (!lastSlide()) {
                e.preventDefault();
                navigateNext();
             }
          }
        }
      });
  
     heroCarousel.addEventListener("wheel", function (e) {
       let delta = e.wheelDelta || e.deltaY;
  
       if (delta > 0 || e.detail < 0) {
         if (firstSlide()) {
           return;
         }
         e.preventDefault();
         if (animation) return;
         navigatePrevious();
       }

       if (delta < 0 || e.detail > 0) {
         if (lastSlide()) {
           if (animation) {
             e.preventDefault();
             return;
           }
           navigateAfter(false);
           return;
         }
         e.preventDefault();
         if (animation) return;
         navigateNext();
       }
     });
    }
    
    addBullets();
    addEventListeners();

    
    slider
      .querySelectorAll(".hero-carousel-slide")
      .forEach((slide) => slide.classList.add("hide"));
    slides[0].classList.remove("hide");
  }

  return function init(args) {
    if (
      !args.isExperienceEditor &&
      window.matchMedia("(min-width: 700px)").matches
    ) {
      HeroCarousel(args, args.animationSpeed);
    }
  };
});
